import { AuthContext } from '@repo-level/core-front';
import { pushThirdPartySummaries } from 'api/cms/thirdPartySummaries';
import { AddonsContext } from 'contexts/addons';
import { RealTimeServiceContext } from 'contexts/realTimeService';
import { getAvailableJackpotModal } from 'helpers/jackpot';
import { useContext, useEffect, useMemo } from 'react';
import { ModalsContext, ModalType } from '../contexts/modal';

export const useJackpotWinnerModal = () => {
  const { user } = useContext(AuthContext);
  const { jackpotWins } = useContext(RealTimeServiceContext);
  const { handleModal } = useContext(ModalsContext);
  const { thirdPartySummaries } = useContext(AddonsContext);

  const activeModal = useMemo(
    () => getAvailableJackpotModal(user?.id, thirdPartySummaries, jackpotWins),
    [jackpotWins, thirdPartySummaries, user?.id]
  );

  useEffect(() => {
    if (!(user?.id && activeModal?.modalData && activeModal?.modalId)) return;

    handleModal(ModalType.WinnerJackpot)();
    pushThirdPartySummaries({
      userId: user?.id,
      modalId: activeModal.modalId,
    });
  }, [activeModal, handleModal, user?.id]);
};
